"use strict";

/* Global Jquery */
global.jQuery = require("jquery");
window.jQuery = window.$ = jQuery;
require("./partials/paginating");
/* Swiper.js  slider */
import { slider } from "./partials/slider";
import * as bootstrap from "bootstrap5";
import "select2/dist/js/select2.full.min.js";
//import './partials/members'
import axios from "axios";
import swal2 from "sweetalert2";
/* Animejs animation library - https://animejs.com/ */
import anime from "animejs";

import { WOW } from "wowjs";
import { validate } from "jquery-validation";

import UAParser from "ua-parser-js";

/* import './partials/member_new'; */

//new WOW().init();
(function () {
  let main = {
    data: {
      breakpoints1: {
        100: {
          slidesPerView: "auto",
          freeMode: true,
          slidesPerGroup: 1,
          freeModeSticky: true,
        },
        350: {
          slidesPerView: "auto",
          freeMode: true,
          slidesPerGroup: 1,
          freeModeSticky: true,
        },
        801: {
          slidesPerView: "auto",
          freeMode: true,
          slidesPerGroup: 1,
          freeModeSticky: true,
        },
        1201: {
          slidesPerView: 1,
          slidesToScroll: 1,
          freeMode: false,
          freeModeSticky: false,
        },
      },
      breakpoints2: {
        100: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        350: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        801: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        1201: {
          slidesPerView: "auto",
          slidesToScroll: 2,
          freeMode: false,
          freeModeSticky: false,
        },
      },
      breakpoints3: {
        100: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        350: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        801: {
          slidesPerView: 2,
          slidesToScroll: 2,
          slidesPerGroup: 2,
          freeMode: false,
          freeModeSticky: false,
        },
        1201: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          slidesToScroll: 3,
          freeMode: false,
          freeModeSticky: false,
        },
      },
      breakpoints4: {
        100: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        350: {
          slidesPerView: "auto",
          freeMode: true,
          freeModeSticky: true,
        },
        801: {
          slidesPerView: 2,
          slidesToScroll: 2,
          freeMode: false,
          freeModeSticky: false,
        },
        1024: {
          slidesPerView: 3,
          slidesToScroll: 3,
          slidesPerGroup: 3,
          freeMode: false,
          freeModeSticky: false,
        },
        1440: {
          slidesPerView: 4,
          slidesToScroll: 4,
          slidesPerGroup: 4,
          freeMode: false,
          centerMode: false,
        },
      },
    },

    navigation: function () {
      const $header = $("#top-header");
      $(window).on("scroll", function () {
        if ($(window).scrollTop() > 5) {
          $header.addClass("sticky");
        } else {
          $header.removeClass("sticky");
        }
      });

      $(".mobile_toggle_btn").click(function (event) {
        event.preventDefault();
        // $(".site_menu_list").fadeToggle();
        if ($(this).hasClass("active")) {
          $(".menu-wrpr").fadeOut();
        } else {
          $(".menu-wrpr").fadeIn();
        }
        $(this).toggleClass("active");
        return false;
      });

      $(".menu-icon").on("click", function () {
        $(this).toggleClass("active_desktop");
        $(".secondary-menu").fadeToggle();
      });
    },

    sliders: function () {
      let _breakpoints1 = this.data.breakpoints1;
      let _breakpoints2 = this.data.breakpoints2;
      let _breakpoints3 = this.data.breakpoints3;
      let _breakpoints4 = this.data.breakpoints4;

      const membersSlider = slider("#ourmember-carousel", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 24,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#member-next-btn",
          prevEl: "#member-prev-btn",
        },
        breakpoints: _breakpoints4,
        //autoplay: true
      });

      const madeTalk = slider("#madeTalk-carousel", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 24,
        freeModeSticky: false,
        navigation: {
          nextEl: "#madeTalk-next-btn",
          prevEl: "#madeTalk-prev-btn",
        },
        breakpoints: _breakpoints4,
        //autoplay: true
      });

      const memberStoriesSlider = slider("#success-stories-carousel", {
        watchOverflow: true,
        watchSlidesVisibility: true,
        slidesPerView: 3,
        spaceBetween: 0,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#success-stories-next-btn",
          prevEl: "#success-stories-prev-btn",
        },
        breakpoints: _breakpoints3,
      });

      const testimonialsSlider = slider("#testimonial-carousel", {
        watchOverflow: false,
        slidesPerView: 1,
        spaceBetween: 50,
        freeModeSticky: false,
        navigation: {
          nextEl: "#testimonial-next",
          prevEl: "#testimonial-prev",
        },
        breakpoints: _breakpoints1,
      });

      const eventsSlider = slider("#events-carousel", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 24,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#event-next-btn",
          prevEl: "#event-prev-btn",
        },
        breakpoints: _breakpoints3,
      });
      const pDemoSlider = slider("#platformDemo-carousel", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 24,
        freeModeSticky: false,
        navigation: {
          nextEl: "#platformDemo-next-btn",
          prevEl: "#platformDemo-prev-btn",
        },
        breakpoints: _breakpoints3,
      });
      const memberStory = slider("#memberStory-carousel", {
        watchOverflow: false,
        slidesPerView: 1,
        spaceBetween: 80,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#story-next-btn",
          prevEl: "#story-prev-btn",
        },
        breakpoints: _breakpoints1,
      });
      memberStory.on("slideChange", function () {
        $("#numberSlides").html("0" + (this.activeIndex + 1));
      });
      const newsSlider = slider("#news-carousel", {
        watchOverflow: true,
        slidesPerView: "auto",
        slidesPerGroup: 3,
        autoHeight: true,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#news-next-btn",
          prevEl: "#news-prev-btn",
        },
        //breakpoints: _breakpoints2,
      });
      const homeBanner = slider("#home-banner", {
        watchOverflow: false,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        freeModeSticky: false,
        lazy: true,
        navigation: {
          nextEl: "#banner-next-btn",
          prevEl: "#banner-prev-btn",
        },
        //autoplay:false,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        loop: true,
        //breakpoints: _breakpoints4
      });
    },

    footer: function () {
      $("a.footer-menu--toggle").on("click", (event) => {
        event.preventDefault();
        if ($(event.target).parent().next().first().is(":hidden")) {
          $(event.target).parent().next().slideDown();
          $(event.target).addClass("expanded");
        } else {
          $(event.target).parent().next().slideUp();
          $(event.target).removeClass("expanded");
        }
      });
    },

    members: function () {
      $(".drop-list").on("click", function () {
        var tab_id = $(this).attr("acc-id");
        $(".drop-list").removeClass("active");
        $(".filter-container").removeClass("active");
        $(this).addClass("active");
        $("#" + tab_id).addClass("active");
      });
      $("#sic_button,.btn__memberFilter__SIC").on("click", function (e) {
        $("#filter_container").removeClass("show___filter").hide();
        $("#filter_container").hide();
        $(this).toggleClass("show___filter");
        $("#sic_container").toggle();
      });
      $("#filter_button, .mobile__memberFilter").on("click", function (e) {
        /* if($(this).hasClass("show___filter")) {
          $(this).removeClass("show___filter");
          $('.filter--dropDownContainer').hide();
        }else{
            $(this).addClass("show___filter");
            $('.filter--dropDownContainer').show();
        } */
        $("#sic_container").removeClass("show___filter").hide();
        $(this).toggleClass("show___filter");
        $("#filter_container").toggle();
      });
      $(".close__dropdown").on("click", function () {
        $(".btn__memberFilter,.mobile__memberFilter").removeClass(
          "show___filter"
        );
        $("#filter_container").hide();
      });
      $(document).mouseup(function (e) {
        var container = $(".filter--dropDownWarp");
        var toHide = $(".filter--dropDownContainer");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          toHide.hide();
          $(".btn__memberFilter,.mobile__memberFilter").removeClass(
            "show___filter"
          );
        }
      });
      $(".toggle__acc").on("click", function (e) {
        let getTheID = $(this).data("option_id");
        if ($("#" + getTheID).hasClass("active")) {
          $("#" + getTheID).removeClass("active");
          $("#" + getTheID).slideUp();
        } else {
          $(".options_container").removeClass("active");
          $(".options_container").slideUp();
          $("#" + getTheID).addClass("active");
          $("#" + getTheID).slideDown();
        }
        let arrow_down_n = $(this).find("img");
        let arrow_down = "/frontend_new/assets/images/arrow-down.svg";
        let arrow_up = "/frontend_new/assets/images/arrow-up.svg";
        if (arrow_down_n.attr("src") == arrow_down) {
          arrow_down_n.attr("src", arrow_up);
        } else {
          arrow_down_n.attr("src", arrow_down);
        }
      });
      $(".toggle___acc").on("click", function (e) {
        let getTheID = $(this).data("option_id");
        if ($("#" + getTheID).hasClass("active")) {
          $("#" + getTheID).removeClass("active");
          $("#" + getTheID).slideUp();
        } else {
          $(".option----CheckboxCon").removeClass("active");
          $(".option----CheckboxCon").slideUp();
          $("#" + getTheID).addClass("active");
          $("#" + getTheID).slideDown();
        }
        let arrow_down_n = $(this).find("img");
        let arrow_down = "/frontend_new/assets/images/arrow-down.svg";
        let arrow_up = "/frontend_new/assets/images/arrow-up.svg";
        if (arrow_down_n.attr("src") == arrow_down) {
          arrow_down_n.attr("src", arrow_up);
        } else {
          arrow_down_n.attr("src", arrow_down);
        }
      });

      $(".apply_filter_btn").click(function () {
        $(".drop-list").removeClass("active");
        $(".filter-container").removeClass("active");
      });
      $("#show-map-btn,.innner-show-map-btn").on("click", function () {
        $(".ifrm-wrpr").toggle();
        $(".map-ifrm").toggleClass("show-map");
        if ($(this).children("span").text() == "Show Map") {
          $(this).children("span").text("Hide Map");
        } else {
          $(this).children("span").text("Show Map");
        }
      });
      $(".mobile-map-close").click(function () {
        $(".mobile-map-sec").fadeOut();
        $(".innner-show-map-btn").fadeIn();
        $("#map-canvas-mobile").removeClass("map-canvas");
        $("#map-canvas").addClass("map-canvas");
        initMap();
      });
      $(".filter-btn-inner-dv").click(function () {
        $(".mobile-filter-section").fadeIn();
        $(".mobile-map-sec").fadeOut();
      });
      $(".mobile-filter-close").click(function () {
        $(".mobile-filter-section").fadeOut();
      });
      $(".mb-filter-name ul li").click(function () {
        var tab_id = $(this).attr("acc-mb-id");
        $(".mb-filter-name ul li").removeClass("active");
        $(".mb-filter-container").removeClass("active");
        $(this).addClass("active");
        $("#" + tab_id).addClass("active");
      });
      $(".apply-close-btn button").click(function () {
        $(".mobile-filter-section").fadeOut();
      });
      $(".mobile-submit").on("click", function () {
        var form = $(this).attr("data-formid");
        $(form).submit();
      });
      $(document).on("click", ".open_quick_view", function (event) {
        event.preventDefault();
        $(".quick_view").addClass("d-none");
        $(".quick_view").removeClass("d-none");
        var url = $(this).attr("data-site_url");
        var cname = $(this).attr("data-company_name");
        $(".company_name").text(cname);
        $(".urlArea,#hiddenCopyText").text(url);
        $("iframe.micrositeIframe").attr("src", url);
        $("a.urlChange").attr("href", url);
      });
      $(document).on("click", ".close-quick_view", function () {
        $(".quick_view").addClass("d-none");
        $("iframe.micrositeIframe").attr("src", "");
      });
      $(document).on("click", ".show3dTour", function (event) {
        $("iframe#openTourPopupIframe").attr("src", "");
        event.preventDefault();
        let video_url = $(this).data("src");
        let video_title = $(this).data("member_name");
        let microsite = $(this).data("microsite");
        $("#openTourPopupLabel").text(video_title);
        $("iframe#openTourPopupIframe").attr("src", video_url);
        $("a#visitMicrosite").attr("href", microsite);
      });
      $("#openTourPopup").on("hide.bs.modal", function () {
        $("iframe#openTourPopupIframe").attr("src", "");
        $("a#visitMicrosite").attr("href", "#");
      });
    },
    copyText: function () {
      $("#copyUrl").on("click", function () {
        var getText = $("p#hiddenCopyText").text();
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(getText).select();
        document.execCommand("copy");
        $temp.remove();

        var tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = "Copied";
      });
      $("#copyUrl").on("mouseout", function () {
        var tooltip = document.getElementById("copyTooltip");
        tooltip.innerHTML = "Copy URL";
      });
    },
    accordion: function () {
      /* $(".collapse").each((index, element) => {
        new bootstrap.Collapse(element);
      }); */
    },

    register: function () {
      let currentStep = $(".register-step__content.active");
      let prgress = 0;

      function updateProgress() {
        if ($("a.register-progress-btn.active").length) {
          let _height = $(
            "a.register-progress-btn.active .register-step__circle"
          ).height();
          let _offsetLeft = $(
            "a.register-progress-btn.active .register-step__circle"
          ).offset().left;
          prgress = Math.round(
            ((_offsetLeft -
              $(".register-progress").offset().left +
              _height / 2) /
              $(".register-progress").width()) *
              100
          );
          $("#register-form__progress").css("width", prgress + "%");
        }
      }

      function isMembershipStep() {
        return $("#step-membership").is(":visible");
      }

      function openFreeTrialModal() {
        $("#made-navigator-modal").fadeIn();
        $("#made-navigator-modal").addClass("active");
      }

      updateProgress();

      function goToStep(stepId, stepBtn) {
        if (isMembershipStep()) {
          if (
            $("input.radio-membership-type:checked")
              .data("name")
              .toLowerCase() === "freemium" ||
            $("input.radio-membership-type:checked")
              .data("name")
              .toLowerCase() === "made navigator" ||
            $("input.radio-membership-type:checked")
              .data("name")
              .toLowerCase() === "made navigator online"
          ) {
            openFreeTrialModal();
            return;
          }
        }

        if (stepId && stepId.length > 0) {
          $(".register-step__content").hide();

          if (stepId.indexOf("#") == -1) {
            stepId = "#" + stepId;
          }

          $(stepId).show();

          $("a.register-progress-btn").removeClass("active");
          $('a.register-progress-btn[href="' + stepId + '"]').addClass(
            "active"
          );
        }
      }

      $("a.register-progress-btn").on("click", (event) => {
        event.preventDefault();

        let btn = $(event.target);
        let stepId = btn.attr("href") || btn.data("target");

        goToStep(stepId, false);

        updateProgress();
      });

      $(".register-btn").on("click", (event) => {
        event.preventDefault();

        let btn = $(event.target);
        let stepId = btn.data("target") || btn.attr("href");

        goToStep(stepId, true);

        updateProgress();
      });

      $("button.option__view-details").on("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        let _btn = $(event.target);
        if (_btn.parent().parent().parent().parent().hasClass("show-details")) {
          _btn
            .parent()
            .parent()
            .parent()
            .parent()
            .find(".membership__option--details")
            .slideUp();
          _btn.parent().parent().parent().parent().removeClass("show-details");
        } else {
          _btn
            .parent()
            .parent()
            .parent()
            .parent()
            .find(".membership__option--details")
            .slideDown();
          _btn.parent().parent().parent().parent().addClass("show-details");
        }
      });

      $("input.radio-membership-type").change((event) => {
        let _input = $(event.target);
        if (
          _input.data("name").toLowerCase() === "freemium" ||
          _input.data("name").toLowerCase() === "made navigator" ||
          _input.data("name").toLowerCase() === "made navigator online"
        ) {
          openFreeTrialModal();
        } else {
          $("#membership-type").removeClass("active");
          $("#membership-type").addClass("done");
          $("#user-details").addClass("active");
        }

        let _planId = _input.data("plan-id");
        if (_planId && _planId.length > 0) {
          $(".selected-membership").removeClass("active");
          $("#" + _planId).addClass("active");
          $(".selected-membership").hide();
          $("#" + _planId).show();
        }
      });

      $("input.register-input").on("change input", (event) => {
        let _input = $(event.target);
        let _value = _input.val();
        let _inputConfirm = _input.attr("id");
        $("." + _inputConfirm).text(_value);
      });

      $("input.register-checkbox").on("change", (event) => {
        let _input = $(event.target);
        let _inputConfirm = _input.attr("id");
        if (_input.is(":checked")) {
          $("." + _inputConfirm).addClass("checked");
        } else {
          $("." + _inputConfirm).removeClass("checked");
        }
      });

      $(".start__trial--btn").click(function (e) {
        event.preventDefault();
        let target = $(this).data("target");
        $("#" + target).fadeIn();
        $("#" + target).addClass("active");
      });

      $(".made-navigator-close").click(function (event) {
        event.preventDefault();
        $(".modal").removeClass("active");
        $("#made-navigator-modal").fadeOut();
        $("#made-navigator-modal").removeClass("active");
        $("#membership-type").removeClass("done");
        $("#membership-type").removeClass("active");
        $("input.radio-membership-type").each(function (index, element) {
          if (!$(element).is(":checked")) {
            $(element).parent().slideDown();
          }
        });
      });

      $("#made-navigator-modal").click(function (event) {
        event.preventDefault();
        $(".modal").removeClass("active");
        $("#made-navigator-modal").removeClass("active");
        $("#made-navigator-modal").fadeOut();
        $("#membership-type").removeClass("done");
        $("#membership-type").removeClass("active");
        $("input.radio-membership-type").each(function (index, element) {
          if (!$(element).is(":checked")) {
            $(element).parent().slideDown();
          }
        });
      });

      $("form.needs-validation").on("submit", (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }

        $(event.target).addClass("was-validated");
      });
    },
    // homeWhyJonUs: function(){
    //     var homeWhyJonUs = document.querySelector('#homeWhyJonUs')
    //     var carousel = new bootstrap.Carousel(homeWhyJonUs, {
    //         //interval: 5000,
    //         //wrap: false,
    //         pause: 'hover'
    //      })
    // },
    wow: function () {
      new WOW().init();
    },
    registerv2: function () {
      //let form_r = $("#register-form");
      jQuery.validator.addMethod(
        "postcode_rule",
        function (value, element) {
          if (
            /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/.test(
              value.toUpperCase()
            )
          ) {
            return true;
          } else {
            return false;
          }
        },
        "Please enter valid Postcode"
      );
      var form_r = $("form#register-form").validate({
        rules: {
          email: {
            required: true,
            email: true,
            remote: {
              url: "/api/v1/users/email",
              dataFilter: function (data) {
                var json = JSON.parse(data);
                if (json.success === true) {
                  return true;
                } else {
                  return false;
                }
              },
            },
          },
          "user[first_name]": {
            required: true,
          },
          "user[last_name]": {
            required: true,
          },
          "member[name]": {
            required: true,
          },
          "user[password]": "required",
          "user[password_confirmation]": {
            equalTo: "#passwordInput",
          },
          "user[company_position]": {
            required: true,
          },
          "contact_details[telephone]": {
            required: true,
          },
          /* "member[name]": {
              required: true,
            }, */
          "contact_details[address_line_1]": {
            required: true,
          },
          "contact_details[location]": {
            required: true,
          },
          "contact_details[postcode]": {
            required: true,
            postcode_rule: true,
          },
        },
        messages: {
          "member[name]": {
            required: "Please enter company name",
          },
          "user[first_name]": {
            required: "Please enter first name",
          },
          "user[last_name]": {
            required: "Please enter last name",
          },
          "user[password]": {
            required: "Please enter password",
          },
          "user[password_confirmation]": {
            required: "Confirm Password is required",
            equalTo: "Passwords do not match",
          },
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
            remote: "This email address is already in use",
          },
          "user[company_position]": {
            required: "Please enter Company Position",
          },
          "contact_details[telephone]": {
            required: "Please enter Telephone",
          },
          /* "member[name]": {
              required: "Please enter Company Name",
            }, */
          "contact_details[address_line_1]": {
            required: "Please enter Address",
          },
          "contact_details[location]": {
            required: "Please select Location",
          },
          "contact_details[postcode]": {
            required: "Please enter Postcode",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error").removeClass("success");
          $(element)
            .parent()
            .children("label")
            .addClass("er")
            .removeClass("success");
        },
        unhighlight: function (element) {
          $(element).removeClass("error").addClass("success");
          $(element)
            .parent()
            .children("label")
            .removeClass("er")
            .addClass("success");
        },
      });
      $("#goToStep2").on("click", function (event) {
        event.preventDefault();
        if (form_r.form()) {
          $("#step-1").hide();
          $("#step-2").show();
        }
      });
      $("#registerFormSubmit").on("click", function (event) {
        event.preventDefault();
        if (form_r.form()) {
          $("form#register-form").submit();
        }
      });
      // Binding next button on second step
      $(".showVideoPop").on("click", function (event) {
        $("iframe#youtubeVideoIframe").attr("src", "");
        event.preventDefault();
        let video_id = $(this).data("video_id");
        let video_title = $(this).data("video_name");
        $("#openVideoPopupLabel").text(video_title);
        let video_url = "https://www.youtube.com/embed/" + video_id;
        $("iframe#youtubeVideoIframe").attr("src", video_url);
      });
      $("#openVideoPopup").on("hide.bs.modal", function () {
        $("iframe#youtubeVideoIframe").attr("src", "");
      });
    },
    applyJob: function () {
      $(".show__job__filter").on("click", function () {
        $(".job__filter_toggle").toggleClass("d-none");
      });
      var form_cv = $("form#apply").validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
          name: {
            required: true,
          },
          telephone: {
            required: true,
          },
          cv: {
            required: true,
            extension: "png|jpe?g|pdf|doc|docx",
          },
        },
        messages: {
          name: {
            required: "Please enter full name",
          },
          cv: {
            required: "Please upload your CV",
            extension: "File must be JPG, GIF or PNG and less than 10MB",
          },
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
          },
          telephone: {
            required: "Please enter Telephone",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error");
          $(element).parent().children("label").addClass("er");
        },
        unhighlight: function (element) {
          $(element).removeClass("error");
          $(element).parent().children("label").removeClass("er");
        },
      });
      $("#applyNow").on("click", function (event) {
        event.preventDefault();
        if (form_cv.form()) {
          $("form#apply").submit();
        }
      });
    },
    contactFormSubmit: function () {
      var form_contact = $("form#contactForm").validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
          name: {
            required: true,
          },
          phone: {
            required: true,
          },
          message: {
            required: true,
          },
        },
        messages: {
          name: {
            required: "Please enter full name",
          },
          message: {
            required: "Please enter your message",
          },
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
          },
          phone: {
            required: "Please enter phone",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error");
          $(element).parent().children("label").addClass("er");
        },
        unhighlight: function (element) {
          $(element).removeClass("error");
          $(element).parent().children("label").removeClass("er");
        },
      });
      $("#contactSubmit").on("click", function (event) {
        event.preventDefault();
        if (form_contact.form()) {
          $("form#contactForm").submit();
        }
      });
    },
    bursaryFormSubmit: function () {
      var form_bursary = $("form#bursary__signup-form").validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          company_name: {
            required: true,
          },
          telephone: {
            required: true,
          },
          message: {
            required: true,
          },
        },
        messages: {
          first_name: {
            required: "Please enter first name",
          },
          last_name: {
            required: "Please enter last name",
          },
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
          },
          telephone: {
            required: "Please enter phone",
          },
          message: {
            required: "Please enter message",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error");
          $(element).parent().children("label").addClass("er");
        },
        unhighlight: function (element) {
          $(element).removeClass("error");
          $(element).parent().children("label").removeClass("er");
        },
      });
      $("#bursarySubmit").on("click", function (event) {
        event.preventDefault();
        if (form_bursary.form()) {
          $("form#bursary__signup-form").submit();
        }
      });
    },
    eventsPage: function () {
      $(".btn-event-filter").on("click", function () {
        let eType = $(this).attr("data-event_type");
        let eCount = $(this).attr("data-event_count");
        $(".btn-event-filter").removeClass("active");
        $(this).addClass("active");
        if (eCount > 0) {
          $("#eventCount").text(eCount);
        } else {
          $("#eventCount").text("0");
        }

        if (eType == "Past") {
          $("#upcomingEvents").addClass("d-none");
          $("#pastEvents,.pastEvents---pagination").removeClass("d-none");
          $("#eventType").text("Past");
        }
        if (eType == "Upcoming") {
          $("#pastEvents,.pastEvents---pagination").addClass("d-none");
          $("#upcomingEvents").removeClass("d-none");
          $("#eventType").text("Upcoming");
        }
      });
      $("#pastEvents").paginathing({
        //perPage: 10, // show item per page
        /*limitPagination: false, // false or number. Limiting your pagination number.
      prevNext: true, // enable previous and next button
      firstLast: true, // enable first and last button
      prevText: '&laquo;', // Previous button text
      nextText: '&raquo;', // Next button text
      firstText: 'First', // "First button" text
      lastText: 'Last', // "Last button" text
      containerClass: 'pagination-container', // extend default container class
      ulClass: 'pagination', // extend default ul class
      liClass: 'page', // extend li class
      activeClass: 'active', // active link class
      disabledClass: 'disable' // disabled link class,
      insertAfter: null //class or id (eg: .element or #element). append the paginator after certain element
      pageNumbers: false // showing current page number of total pages number, to work properly limitPagination must be true  */
        firstLast: false,
        perPage: 9,
        limitPagination: 3,
        containerClass:
          "pastEvents---pagination d-flex align-items-center justify-content-center d-none",
        ulClass: "event---pagination d-flex gap-2",
      });
    },
    factoryTour: () => {
      $("#3d-search-form").on("submit", (event) => {
        event.preventDefault();
        let tenants = [];
        $("#filter-tenants, #filter-tenants-mobile")
          .find(":checked")
          .each(function () {
            tenants.push($(this).val());
          });
        tenants = tenants.join(",");
        let accreditations = [];
        $("#filter-accreditations, #filter-accreditations-mobile")
          .find(":checked")
          .each(function () {
            accreditations.push($(this).val());
          });
        accreditations = accreditations.join(",");

        let buys = [];
        $("#filter-buys, #filter-buys-mobile")
          .find(":checked")
          .each(function () {
            buys.push($(this).val());
          });
        buys = buys.join(",");

        let sells = [];
        $("#filter-sells, #filter-sells-mobile")
          .find(":checked")
          .each(function () {
            sells.push($(this).val());
          });
        sells = sells.join(",");
        window.history.replaceState(
          {},
          "",
          `3d-factory-tours?tenants=${tenants}&accreditations=${accreditations}&buys=${buys}&sells=${sells}`
        );
        location.reload();
      });
    },
    microsite_ind: () => {
      $(".companyRole").select2({
        placeholder: "Company Role",
        theme: "bootstrap-5",
      });
      $("#accreditations").select2({
        placeholder: "What accreditations do you hold?",
        theme: "bootstrap-5",
      });
      $("#sell_services").select2({
        placeholder:
          "What are the 5 most common products or services you SELL?",
        theme: "bootstrap-5",
      });
      $("#buy_services").select2({
        placeholder: "What are the 5 most common products or services you BUY?",
        theme: "bootstrap-5",
      });
    },
    micrositeInduction: () => {
      var form_mi = $("form#micrositeInduction").validate({
        rules: {
          user_1_email: {
            required: true,
            email: true,
          },
          user_1: {
            required: true,
          },
          company_role_1: {
            required: true,
          },
          year_founded: {
            required: true,
          },
          backing_britain: {
            required: true,
          },
          business_main_activity: {
            required: true,
          },
          "accreditations[]": {
            required: true,
          },
        },
        messages: {
          user_1: {
            required: "Please enter user 1 name",
          },
          user_1_email: {
            required: "Please enter email address",
            email: "Please enter a valid email address.",
          },
          user_1_role: {
            required: "Please select company role",
          },
          year_founded: {
            required: "Please enter founded year",
          },
          backing_britain: {
            required: "Please tell us about you",
          },
          business_main_activity: {
            required: "Please describe business main activity",
          },
          "accreditations[]": {
            required: "Please select accreditations",
          },
        },
        errorElement: "i",
        /* errorPlacement: function (error, element) {
					var elem = $(element);
					error.insertAfter(element);
				}, */
        highlight: function (element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            $("#select2-" + elem.attr("id") + "-container")
              .parent()
              .addClass("er")
              .addClass("error")
              .removeClass("success");
          } else {
            $(element).addClass("error").removeClass("success");
            $(element)
              .parent()
              .children("label")
              .addClass("er")
              .removeClass("success");
          }
        },
        unhighlight: function (element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            $("#select2-" + elem.attr("id") + "-container")
              .parent()
              .removeClass("error")
              .removeClass("er")
              .addClass("success")
              .show();
          } else {
            $(element).removeClass("error").addClass("success");
            $(element)
              .parent()
              .children("label")
              .removeClass("er")
              .addClass("success");
          }
        },
        errorPlacement: function (error, element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            element = $("#select2-" + elem.attr("id") + "-container").parent();
            error.insertAfter(element);
          } else {
            error.insertAfter(element);
          }
        },
      });
      $(".web-select2").on("select2:select", function (e) {
        form_mi.form();
      });
      $("#step_1_next,#organization_button_top").on("click", function (event) {
        event.preventDefault();
        if (form_mi.form()) {
          $("#contact,#image_logo,#finish").addClass("d-none");
          $("#organization").removeClass("d-none");
          $("#image_logo_button_top,#contact_button_top,#finish_top").addClass(
            "btn-default--induction"
          );
          $("#organization_button_top")
            .addClass("btn-success--wizard")
            .removeClass("btn-default--induction");
        }
      });
      $("#step_2_next,#image_logo_button_top").on("click", function (event) {
        event.preventDefault();
        if (form_mi.form()) {
          $("#organization,#contact,#finish").addClass("d-none");
          $("#image_logo").removeClass("d-none");
          $(
            "#organization_button_top,#contact_button_top,#finish_top"
          ).addClass("btn-default--induction");
          $("#image_logo_button_top")
            .addClass("btn-success--wizard")
            .removeClass("btn-default--induction");
        }
      });
      $("#go_back_step_1,#contact_button_top,#go_back_last").on(
        "click",
        function () {
          event.preventDefault();
          $("#contact").removeClass("d-none");
          $("#organization,#image_logo,#finish").addClass("d-none");
          $(
            "#organization_button_top,#image_logo_button_top,#finish_top"
          ).addClass("btn-default--induction");
          $("#contact_button_top")
            .addClass("btn-success--wizard")
            .removeClass("btn-default--induction");
        }
      );
      $("#go_back_step_2").on("click", function () {
        event.preventDefault();
        $("#organization").removeClass("d-none");
        $("#contact,#image_logo,#finish").addClass("d-none");
        $("#contact_button_top,#image_logo_button_top,#finish_top").addClass(
          "btn-default--induction"
        );
        $("#organization_button_top")
          .addClass("btn-success--wizard")
          .removeClass("btn-default--induction");
      });
      $("#step_3_complete,#finish_top").on("click", function (event) {
        event.preventDefault();
        if (form_mi.form()) {
          //$('form#micrositeInduction').submit();
          $("#step_3_complete").addClass("d-none");
          $("#step_3_complete_loading").removeClass("d-none");

          let form__MI = document.getElementById("micrositeInduction");
          let action_url = $("form#micrositeInduction").attr("action");
          let formData = new FormData(form__MI);
          //console.log(action_url);
          $.ajax({
            type: "POST",
            cache: false,
            url: action_url,
            data: formData,
            success: (data) => {
              //console.log('Data returned from server => ', data);
              $("#step_3_complete").removeClass("d-none");
              $("#step_3_complete_loading").addClass("d-none");
              $("#finish").removeClass("d-none");
              $("#contact,#image_logo,#organization").addClass("d-none");
              $(
                "#contact_button_top,#image_logo_button_top,#organization_button_top"
              ).addClass("btn-default--induction");
              $("#finish_top")
                .addClass("btn-success--wizard")
                .removeClass("btn-default--induction");
            },
            contentType: false,
            processData: false,
          });
        }
      });
    },
    footerDigest: function () {
      var form_footer = $("form#footerDigest").validate({
        rules: {
          email: {
            required: true,
            email: true,
          },
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          communication: {
            required: true,
          },
        },
        messages: {
          first_name: {
            required: "Please enter first name",
          },
          last_name: {
            required: "Please enter last name",
          },
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error");
          $(element).parent().children("label").addClass("er");
        },
        unhighlight: function (element) {
          $(element).removeClass("error");
          $(element).parent().children("label").removeClass("er");
        },
      });
      $("#footerDigest__b").on("click", function (event) {
        event.preventDefault();
        if (form_footer.form()) {
          event.preventDefault(); //prevent default action
          let post_url = $("form#footerDigest").attr("action"); //get form action url
          let request_method = $("form#footerDigest").attr("method"); //get form GET/POST method
          let form_data = $("form#footerDigest").serialize(); //Encode form elements for submission
          $.ajax({
            url: post_url,
            type: request_method,
            data: form_data,
          })
            .done(function (response) {
              console.log(response);
              $("#displayMsg").removeClass("d-none");
              $("#showForm").addClass("d-none");
              $("#responseError").addClass("d-none");
              $("#responseSuccess").removeClass("d-none");
              $("#server-results").html(response);
            })
            .fail(function (response) {
              $("#displayMsg").removeClass("d-none");
              $("#responseError").removeClass("d-none");
              $("#responseSuccess").addClass("d-none");
              $("#server-results").html(response);
            });
        }
      });
    },
    forgotPassword: function () {
      var form_forgot = $("form#forgot__password").validate({
        rules: {
          email: {
            required: true,
            email: true,
            remote: {
              url: "/api/v1/users/email",
              dataFilter: function (data) {
                var json = JSON.parse(data);
                if (json.success === true) {
                  return false;
                } else {
                  return true;
                }
              },
            },
          },
        },
        messages: {
          email: {
            required: "Email Address is required",
            email: "Please enter a valid email address.",
            remote: "This email address not found",
          },
        },
        errorElement: "span",
        highlight: function (element) {
          $(element).addClass("error").removeClass("success");
          $(element)
            .parent()
            .children("label")
            .addClass("er")
            .removeClass("success");
        },
        unhighlight: function (element) {
          $(element).removeClass("error").addClass("success");
          $(element)
            .parent()
            .children("label")
            .removeClass("er")
            .addClass("success");
        },
      });
      $("#footerPassword__b").on("click", function (event) {
        event.preventDefault();
        if (form_forgot.form()) {
          event.preventDefault(); //prevent default action
          let post_url = $("form#forgot__password").attr("action"); //get form action url
          let request_method = $("form#forgot__password").attr("method"); //get form GET/POST method
          let form_data = $("form#forgot__password").serialize(); //Encode form elements for submission
          $.ajax({
            url: post_url,
            type: request_method,
            data: form_data,
          })
            .done(function (response) {
              //console.log(response);
              $("#displayMsg_fp").removeClass("d-none");
              $("#showForm_fp").addClass("d-none");
              $("#responseError_fp").addClass("d-none");
              $("#responseSuccess_fp").removeClass("d-none");
              $("#server-results_fp").html(response);
            })
            .fail(function (response) {
              $("#displayMsg_fp").removeClass("d-none");
              $("#responseError_fp").removeClass("d-none");
              $("#responseSuccess_fp").addClass("d-none");
              $("#server-results_fp").html(response);
            });
        }
      });
      $("#staticBackdrop").on("hidden.bs.modal", function () {
        $("#showForm_fp").removeClass("d-none");
        $("#displayMsg_fp").addClass("d-none");
        $("#responseError_fp").addClass("d-none");
        $("#responseSuccess_fp").addClass("d-none");
        $("#forgotPassAddress").val();
      });
    },
    micrositeInductionNew: () => {
      var form_mi_new = $("form#micrositeInductionNew").validate({
        rules: {
          user_1_email: {
            required: true,
            email: true,
          },
          user_1: {
            required: true,
          },
          company_role_1: {
            required: true,
          },
          year_founded: {
            required: true,
          },
          backing_britain: {
            required: true,
          },
          business_main_activity: {
            required: true,
          },
          /* "accreditations[]": {
            required: true,
          },*/
        },
        messages: {
          user_1: {
            required: "Please enter user 1 name",
          },
          user_1_email: {
            required: "Please enter email address",
            email: "Please enter a valid email address.",
          },
          user_1_role: {
            required: "Please select company role",
          },
          year_founded: {
            required: "Please enter founded year",
          },
          backing_britain: {
            required: "Please tell us about you",
          },
          business_main_activity: {
            required: "Please describe business main activity",
          },
          /*"accreditations[]": {
            required: "Please select accreditations",
          },*/
        },
        errorElement: "i",
        /* errorPlacement: function (error, element) {
					var elem = $(element);
					error.insertAfter(element);
				}, */
        highlight: function (element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            $("#select2-" + elem.attr("id") + "-container")
              .parent()
              .addClass("er")
              .addClass("error")
              .removeClass("success");
          } else {
            $(element).addClass("error").removeClass("success");
            $(element)
              .parent()
              .children("label")
              .addClass("er")
              .removeClass("success");
          }
        },
        unhighlight: function (element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            $("#select2-" + elem.attr("id") + "-container")
              .parent()
              .removeClass("error")
              .removeClass("er")
              .addClass("success")
              .show();
          } else {
            $(element).removeClass("error").addClass("success");
            $(element)
              .parent()
              .children("label")
              .removeClass("er")
              .addClass("success");
          }
        },
        errorPlacement: function (error, element) {
          var elem = $(element);
          if (elem.hasClass("select2-hidden-accessible")) {
            element = $("#select2-" + elem.attr("id") + "-container").parent();
            error.insertAfter(element);
          } else {
            error.insertAfter(element);
          }
        },
      });
      $(".web-select2").on("select2:select", function (e) {
        form_mi_new.form();
      });
      $("#stepOneNext").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepOne,#formStepThree,#formStepFour,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepTwo").removeClass("d-none");
        } else {
          /* swal2.fire({
            icon: "error",
            title: "Oops...",
            text: "Please add at least one user from your organisation to progress",
          }); */
          alert(
            "Please add at least one user from your organisation to progress"
          );
        }
      });
      $("#stepTwoNext").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepOne,#formStepTwo,#formStepFour,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepThree").removeClass("d-none");
        }
      });
      $("#stepThreeNext").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepOne,#formStepTwo,#formStepThree,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepFour").removeClass("d-none");
        }
      });
      $("#stepTwoPrev").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepTwo,#formStepThree,#formStepFour,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepOne").removeClass("d-none");
        }
      });
      $("#stepThreePrev").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepOne,#formStepThree,#formStepFour,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepTwo").removeClass("d-none");
        }
      });
      $("#stepFourPrev").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          $("#formStepOne,#formStepTwo,#formStepFour,#formStepFive").addClass(
            "d-none"
          );
          $("#formStepThree").removeClass("d-none");
        }
      });
      $("#goBackToOne").on("click", function () {
        $(
          "#formStepTwo,#formStepThree,#formStepFour,#formStepFive,#formStepFour_loading"
        ).addClass("d-none");
        $("#formStepOne").removeClass("d-none");
      });
      $("#stepFourSubmit").on("click", function (event) {
        event.preventDefault();
        if (form_mi_new.form()) {
          //$('form#micrositeInduction').submit();
          $("#formStepFour").addClass("d-none");
          $("#formStepFour_loading").removeClass("d-none");

          let form__MI__new = document.getElementById("micrositeInductionNew");
          let action_url_new = $("form#micrositeInductionNew").attr("action");
          let formData_new = new FormData(form__MI__new);
          //console.log(action_url);
          $.ajax({
            type: "POST",
            cache: false,
            url: action_url_new,
            data: formData_new,
            success: (data) => {
              //console.log('Data returned from server => ', data);
              $("#formStepFive").removeClass("d-none");
              $("#formStepFour_loading").addClass("d-none");
            },
            contentType: false,
            processData: false,
          });
        }
      });
    },
    init: function () {
      this.navigation();
      this.sliders();
      this.footer();
      this.members();
      this.copyText();
      this.accordion();
      this.register();
      this.wow();
      this.registerv2();
      this.eventsPage();
      this.applyJob();
      this.contactFormSubmit();
      this.bursaryFormSubmit();
      this.factoryTour();
      this.microsite_ind();
      this.micrositeInduction();
      this.micrositeInductionNew();
      this.footerDigest();
      this.forgotPassword();
    },
  };

  main.init();
})();

(function () {
  "use strict";

  let _addressDropdownInitialised;
  let ua = new UAParser();

  let isMobile =
    ua.getDevice().type === "mobile" || ua.getDevice().type === "tablet";

  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });
  $("#enter-manually").click(function () {
    $("#address-wrapper").removeClass("d-none");
  });
  $("#addressPostcode").keypress(function (e) {
    if (e.which === 13) {
      searchPostcode();
      return false;
    }
  });
  $("#search-postcode").click(function () {
    searchPostcode();
  });
  $("#select-address").change(function () {
    $.ajax({
      method: "get",
      url: "/api/v1/loqate/retrieve",
      data: {
        address_id: $(this).val(),
      },
      dataType: "json",
    }).done(function (data) {
      if (data.success) {
        $("#addressLineOne").val(data.data["address_line_1"]);
        let addressLine2 = data.data["address_line_2"];
        if (addressLine2 !== "") {
          addressLine2 += ", " + data.data["address_line_2"];
        } else {
          addressLine2 = data.data["city"];
        }
        $("#addressLineTwo").val(addressLine2);
        $("#contact-details-postcode").val(data.data["postcode"]);
        $("#address-wrapper").removeClass("d-none");
        $("#enter__manually").hide();
      }
    });
  });

  function searchPostcode() {
    if (_addressDropdownInitialised) {
      $("#select-address")[0].selectize.destroy();
      _addressDropdownInitialised = false;
    }

    let postcode = $("#addressPostcode").val();
    if (postcode === "") return;
    $.ajax({
      method: "get",
      url: "/api/v1/loqate/find",
      data: {
        search: postcode,
      },
      dataType: "json",
    }).done(function (data) {
      if (data.success) {
        let message = "Select an address...";

        if (!data.items.length) {
          message = "No addresses found, search again or enter manually";
        }

        let html =
          '<option value="" selected disabled>' + message + "</option>";
        data.items.forEach(function (item) {
          html +=
            '<option value="' +
            item["Id"] +
            '">' +
            item["Text"] +
            ", " +
            item["Description"] +
            "</option>";
        });
        $("#select-address").html(html);
        /* if (!isMobile) {
					$('#select-address').selectize();
					_addressDropdownInitialised = true;
				} */
        $("#select-address-wrapper,#enter__manually").removeClass("d-none");
      }
    });
  }
})();
window.followMember = (id) => {
  axios
    .post("/api/v1/members/search/follow", {
      id: id,
    })
    .then(function (response) {
      let swalre = response.data.swal,
        member = response.data.member;

      if (response.data.redirect === true) {
        swal2({
          //type: swalre.type,
          title: swalre.title,
          text: swalre.text,
          footer:
            '<a href="' + member.microsite + '">Visit ' + member.name + "</a>",
          showCancelButton: true,
          confirmButtonText: "Login",
          cancelButtonText: "Register",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            window.location.href = "/login";
          } else {
            window.location.href = "/register";
          }
        });
      } else {
        swal2({
          type: swalre.type,
          title: swalre.title,
          text: swalre.text,
          footer:
            '<a href="' + member.microsite + '">Visit ' + member.name + "</a>",
        });
        $("#follow__" + id).addClass("d-none");
        $("#follow__" + id + "__ing").removeClass("d-none");
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};
